export default (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/xml");
    const strings = doc.getElementsByTagName("resources")[0].getElementsByTagName("string");
    const output = {};

    for (let i = 0; i < strings.length; i++) {
        const string = strings[i];
        const text = string.textContent;
        const key = string.getAttribute("name");
        const translatable = string.getAttribute("translatable");
        if(text && translatable !== "false") {
            output[key] = unescapePhrase(text);
            console.log(`Parsed key ${key} translatable=${translatable}`)
        }
    }

    console.log(output);

    return output;
}

export const escapePhrase = (phrase) => {
    return phrase
        .replace(/&/g,"&amp;")
        .replace(/'/g, "\\'")
        .replace(/"/g, "\\\"")
};

export const unescapePhrase = (phrase) => {
    return phrase
        .replace(/&amp;/g,"&")
        .replace(/\\'/g, "'")
        .replace(/\\"/g, "\"")
};
